import React, { useEffect, useState, useCallback } from 'react';
import './Navbar.css';

const NAV_ITEMS = [
    { id: 'services', label: 'Услуги' },
    { id: 'product', label: 'Продукт' },
    { id: 'tech', label: 'Технологии' },
];

function BrandMark({ className = '' }) {
    return (
        <span className={`brand-mark ${className}`} aria-hidden="true">
            <img src="/logo-aicoll.webp" alt="" width="512" height="512" />
        </span>
    );
}

function BrandWord({ light = false }) {
    return (
        <span className={`brand-word ${light ? 'brand-word--light' : ''}`}>
            <span className="brand-word-ai">AI</span>
            <span className="brand-word-coll">Coll</span>
        </span>
    );
}

function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleNavClick = useCallback((e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <nav className={`site-nav ${scrolled ? 'is-scrolled' : ''}`}>
            <div className="site-nav-inner">
                <span className="site-nav-sheen" aria-hidden="true" />
                <span className="site-nav-spec" aria-hidden="true" />

                <a href="/" className="nav-brand" aria-label="AIColl — на главную">
                    <BrandMark />
                    <span className="nav-brand-text">
                        <BrandWord />
                        <span className="nav-brand-tag">studio</span>
                    </span>
                </a>

                <ul className="nav-links">
                    {NAV_ITEMS.map((item) => (
                        <li key={item.id}>
                            <a
                                href={`#${item.id}`}
                                className="nav-link"
                                onClick={(e) => handleNavClick(e, `#${item.id}`)}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a href="/app.html" className="nav-cta">
                            <span>Войти</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export { BrandMark, BrandWord };
export default Navbar;
